import validate from "/app/node_modules/.pnpm/nuxt@3.21.8_@parcel+watcher@2.5.6_@types+node@24.10.0_@vue+compiler-sfc@3.5.38_cac@6.7.14_db0_wpkfhih34jfokj32gd6nf7vbge/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.21.8_@parcel+watcher@2.5.6_@types+node@24.10.0_@vue+compiler-sfc@3.5.38_cac@6.7.14_db0_wpkfhih34jfokj32gd6nf7vbge/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}